export const STATUS_INITIALIZED = 0;
export const STATUS_CANCELED = 1;
export const STATUS_DONE = 2;
